export class TabOpenedEventPayload {
    constructor(public openInConversation: boolean, public isRankingOpen?: boolean) {
    }
}
